export const callNumberFormatter = number => {
  return `tel://009${number.replace(/\s/g, '')}`;
};
